















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class BhFlowToolbox extends Vue {
    public async DeleteItemFromDrop(data: any, event: any) {
        if(typeof data.eventHandler === 'function') {
            data.eventHandler({
                data: { type: 'remove' },
                info: data.location,
                event
            });
        }
    }
}
